animateHandler = {
    $animateLayerPinning: $('.layer-pinning'),
    $heroSliderContent: $('#hero-slider-content'),
    $firstHeroContent: $('#first-hero-content'), 
    $footerPanel: $('.footer-panel-container'),
    $panelMenus: $('.panel-menus'),
    $header: $('header'), 
    $animateSlide: $('.animate-slide'),
    smoother: null,
    firstHeroContent: "#first-hero-content",
    isInSection: false,
    scrolled: false, 

    pinningLayer: function(){
        var self = this;

        gsap.registerPlugin(ScrollTrigger);
        gsap.utils.toArray(self.$animateLayerPinning).forEach((panel, i) => { 
            var endAnchor = ( (i+1) < self.$animateLayerPinning.length ) ? "bottom top" : "top top"; 
            
            ScrollTrigger.create({
                trigger: panel,
                start: "top top", 
                end: endAnchor,
                pin: true, 
                pinSpacing: false,
                ease: "none",
                //markers: true,
                snap: 0.8
            });
        });
    },

    setDisplayHeaderFooter: function($show, $initial=false, $hideInitial=false){
        if ($show == true) {
            let strClass = ($initial ? ' initial ' : '');
            this.$header.addClass('showing '+strClass);
            this.$footerPanel.addClass('showing '+strClass);
        } else {
            this.$header.removeClass('showing');
            this.$footerPanel.removeClass('showing');
        }

        if ($hideInitial) {
            this.$header.removeClass('initial');
            this.$footerPanel.removeClass('initial');
        }
    },

    triggerSmooth: function(){
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
        this.smoother = ScrollSmoother.create({
            smooth: 1,      
            effects: true, 
            smoothTouch: 0.5, 
            ignoreMobileResize: true,             
            preventDefault: false,
            //normalizeScroll: true
        });
        this.smoother2 = ScrollSmoother.create({
            smooth: 2,      
            effects: true, 
            smoothTouch: 2, 
            ease: "power4.out",
            ignoreMobileResize: true,             
            preventDefault: false,
            //normalizeScroll: true
        });
        
        if (Foundation.MediaQuery.atLeast("medium")) {
            this.smoother.effects(".parallax-1", {speed: 1.2});
            this.smoother.effects(".parallax-1-large", {speed: 1.2});
            this.smoother.effects(".parallax-2", {speed: 1.1});
            this.smoother.effects(".parallax-3", {speed: 1.3});    
        } else {
            this.smoother.effects(".parallax-1", {speed: 1.1});
            this.smoother.effects(".parallax-1-small", {speed: 1.1});
            this.smoother.effects(".parallax-2", {speed: 1});
            this.smoother.effects(".parallax-3", {speed: 1.2});
        }
    },

    scrollToFirstHeroSection: function() {
        var self = this;
        var interval = 1300;
        mainHandler.initLoad = false;
        self.scrolled = true;
        self.$heroSliderContent.closest('.pin-spacer').animate({height:'0px'}, 1000)
        self.isInSection = true;
        if (Foundation.MediaQuery.is("small")) {
            interval = 1500;
        }
        
        //self.smoother2.paused(false);
        //self.smoother.paused(false);
        self.setDisplayHeaderFooter(true, false, true);
        
        setTimeout(() => {
            self.smoother2.paused(false);
            self.smoother.paused(false);
            self.$firstHeroContent.find('.cell-text').addClass('parallax-2');
            self.$heroSliderContent.closest('.pin-spacer').remove();
            self.triggerSmooth();    
            homeHandler.resizeEvents();
            self.$firstHeroContent.addClass('is-on-top');
        }, interval);
    },

    animateHoverBg: function(){
        var self = this;
        
        gsap.utils.toArray(".menu-item").forEach(menuItem => {
            let hover = gsap.to(self.$panelMenus, {
                backgroundImage: "-webkit-linear-gradient(205deg, #161716 0%, rgba(20,43,36,1) 100%)",
                background: "linear-gradient(205deg, #161716 0%, rgba(20,43,36,1) 100%)", 
                duration: 0.5, 
                paused: true, 
                ease: "power1.inOut"
            });
            
            menuItem.addEventListener("mouseenter", () => hover.play());
            menuItem.addEventListener("mouseleave", () => hover.reverse());
        });
    },

    animateSlideEffect: function() {
        if (this.$animateSlide) {
            this.$animateSlide.each(function(i){
                gsap.from($(this), {
                    delay: 0.08 * i,
                    duration: 1, 
                    ease: "fade.in", 
                    x: -120, 
                    opacity: 0,
                    stagger: 0.02,
                });
            })
        }
    },

    init: function() {
        var self = this;
        var tempY;

        this.triggerSmooth();
        this.pinningLayer();
        
        self.smoother2.paused(true);
        self.smoother.paused(true);

        mainHandler.footerTop = mainHandler.footer.$largeFooter.position().top;
        $(window).on('wheel', function(e){
            if (self.scrolled == false) {
                self.scrollToFirstHeroSection();
            }
        });
        
        $(window).on('touchstart', function(e){
            tempY  = e.changedTouches[0].pageY;
        });
        
        $(window).on('touchmove', function(e){
            let pageY = e.changedTouches[0].pageY;
            if ((pageY !== tempY) && (self.scrolled == false)) {
                self.scrollToFirstHeroSection();   
            }
        });

        $(window).scroll(function(e){
            var scrollTop = $(window).scrollTop();
            var top = self.$firstHeroContent.offset().top; 
            
            if ( scrollTop > top ){
                self.setDisplayHeaderFooter(true);
            } else if ((scrollTop > 1) && (scrollTop < top) && (!self.$firstHeroContent.hasClass('is-on-top'))) {
                //self.setDisplayHeaderFooter(false);
                if (self.scrolled == false) {
                    setTimeout(() => {
                        //$(window).scrollTop(0);
                        self.scrollToFirstHeroSection();
                    }, 150);
                    self.scrolled = true;
                }
                self.smoother2.scrollTo(self.firstHeroContent, true);
            }   
        });
    }
}